import React from 'react';
import { shape, string, bool } from 'prop-types';
import { Col } from '@thd-olt-component-react/core-ui';
import { SyndicationContent } from './SyndicationContent';

export const SyndicationSection = ({ review, syndicationSectionClasses }) => {
  if (!review?.isSyndicated || !review?.syndicationSource) {
    return null;
  }

  const { syndicationSource } = review;
  const { ContentLink, LogoImageUrl, Name } = syndicationSource;
  const isTheCompanyStore = ContentLink?.toLowerCase().includes('thecompanystore.com');

  const syndicationContent = (
    <SyndicationContent logoImageUrl={LogoImageUrl} name={Name} />
  );

  return (
    <Col className={syndicationSectionClasses}>
      {ContentLink && isTheCompanyStore ? (
        <a href={ContentLink} target="_blank" rel="noopener noreferrer">
          {syndicationContent}
        </a>
      ) : (
        <span>
          {syndicationContent}
        </span>
      )}
    </Col>
  );
};

SyndicationSection.displayName = 'SyndicationSection';

SyndicationSection.propTypes = {
  review: shape({
    isSyndicated: bool,
    syndicationSource: shape({
      ContentLink: string,
      LogoImageUrl: string,
      Name: string.isRequired
    })
  }).isRequired,
  syndicationSectionClasses: string
};

SyndicationSection.defaultProps = {
  syndicationSectionClasses: ''
};
